import { Field } from "formik";
import { styled } from "../../../theme";
import { TextField } from "../../../form";
export const Radio = styled(Field) `
  position: relative; /* Ensure proper positioning context */
  appearance: none; /* Remove default browser styling */
  background-color: transparent; /* Ensure background is transparent to avoid default styles */
  border: 0; /* Remove default border */
  ${({ visible }) => !visible && "display: none;"}

  &:before {
    width: 1.375em;
    height: 1.375em;
    border-radius: 50%;
    content: "";
    display: inline-block;
    background-color: ${({ theme }) => theme.color.white};
    border: 2px solid ${({ theme }) => theme.color.primary};
    position: absolute;
    top: -4px;
    left: -6px;
    transform: translateY(-50%); /* Center vertically */
  }

  &:checked:after {
    width: 0.9em;
    height: 0.9em;
    border-radius: 50%;
    content: "";
    display: inline-block;
    background-color: ${({ theme }) => theme.color.primary};
    position: absolute;
    top: -4px;
    left: -1px;
    transform: translateY(-50%); /* Center vertically */
  }

  &:disabled:before {
    border: 2px solid ${({ theme }) => theme.color.gray100};
    background-color: ${({ theme }) => theme.color.gray200}; /* Add a background color for disabled state */
  }
`;
export const ButtonsWrapper = styled.div `
  display: flex;
  justify-content: right;
  gap: ${({ theme }) => theme.space[4]}px;
`;
export const Input = styled(TextField) `
  width: 100%;
  height: 32px;
  box-sizing: border-box;
  padding-top: 3px;
  padding-left: 32px;
  padding-right: 110px;
  font-weight: 500;
  font-size: 15px;
  font-family: Gilroy, sans-serif;
  background-color: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color.darkBlue10};
  border-radius: 100px;

  color: ${({ theme }) => theme.color.darkBlue100};

  &.hiddenEnter {
    padding-right: 26px;
  }
  #243745 ::placeholder {
    color: ${({ theme }) => theme.color.darkBlue100};
    opacity: 0.75;
  }
  :-ms-input-placeholder {
    color: ${({ theme }) => theme.color.darkBlue100};
    opacity: 0.75;
  }
  ::-ms-input-placeholder {
    color: ${({ theme }) => theme.color.darkBlue100};
    opacity: 0.75;
  }
  &:focus {
    border-color: ${({ theme }) => theme.color.primary};
    outline: none;
    ::placeholder {
      color: ${({ theme }) => theme.color.darkBlue100};
    }
    :-ms-input-placeholder {
      color: ${({ theme }) => theme.color.darkBlue100};
    }
    ::-ms-input-placeholder {
      color: ${({ theme }) => theme.color.darkBlue100};
    }
  }
`;
/**
 * Styles for new resident table. It holds information of a resident that is currently being added. When similar residents exists, blue banner is shown which informs user of possible duplicates.
 *
 * @param {boolean} hasSimilarResidents - Whether to show the blue banner.
 */
export const NewResidentBanner = styled.div `
  #similar_resident_radio {
    display: none;
  }

  ${({ hasSimilarResidents, theme, selectable, hasDuplicate }) => hasSimilarResidents &&
    `
 #similar_resident_radio {
    display: ${selectable && !hasDuplicate ? "block" : "none"};
  }

 position: relative;

  & > table > tbody > .list-table__row > td {
    border-bottom: 0;
  }

  & > table > tbody > .list-table__empty-row {
    background-color: ${theme.color.primary}15;
    height: 32px;
  }

  & > table > tbody > tr > td:last-child {
    border-bottom-right-radius: 0px;
  }
  & > table > tbody > tr > td:first-child {
    border-bottom-left-radius: 0px;
  }

  & > table > tbody > .list-table__empty-row > td {
    background-color: ${theme.color.primary}15;
    border-bottom-left-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
   

    &::before {
      display: inline-block;
      text-align: center;
      margin-right: 8px;
      width: 17px;
      height: 17px;
      vertical-align: middle;
      font-size: 15px;
      background: transparent;
      color: ${theme.color.darkBlue100};
      border-radius: 50%;
      border: 2px solid ${theme.color.darkBlue100};
      line-height: 20px;
      font-weight: 800;
      content: "!";
    }

    &::after {
      content: "${hasDuplicate
        ? "This resident already exists."
        : "This resident may already exist."}";
      font-size: 14px;
      vertical-align: middle;
      font-weight: 400;
    }
  }
`}
`;
export const NotMatchingResidentBanner = styled.div `
  #similar_resident_radio {
    display: none;
  }

  ${({ id, theme }) => `
 #similar_resident_radio {
    display: block;
  }

 position: relative;

  & > table > tbody > .list-table__row-${id} > td {
    border-top: 2px solid ${theme.color.errorRed}30;
    border-bottom: 0;
  }

  & > table > tbody > .list-table__empty-row-${id} {
    background-color: ${theme.color.errorRed}15;
    height: 32px;
  }

  & > table > tbody > .list-table__row-${id} > td:last-child {
    border-right: 2px solid ${theme.color.errorRed}30;
    border-bottom-right-radius: 0px;
  }
  & > table > tbody > .list-table__row-${id} > td:first-child {
    border-left: 2px solid ${theme.color.errorRed}30;
    border-bottom-left-radius: 0px;
  }

  & > table > tbody > .list-table__empty-row-${id} > td {
    background-color: ${theme.color.errorRed}15;
    border-bottom-left-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
    border-right: 2px solid ${theme.color.errorRed}30;
    border-left: 2px solid ${theme.color.errorRed}30;
    border-bottom: 2px solid ${theme.color.errorRed}30;
  
    &::before {
      display: inline-block;
      text-align: center;
      margin-right: 8px;
      width: 17px;
      height: 17px;
      vertical-align: middle;
      font-size: 15px;
      background: transparent;
      color: ${theme.color.darkBlue100};
      border-radius: 50%;
      border: 2px solid ${theme.color.darkBlue100};
      line-height: 20px;
      font-weight: 800;
      content: "!";
    }

    &::after {
      content: "This resident information doesn't match.";
      font-size: 14px;
      vertical-align: middle;
      font-weight: 400;
    }
  }
`}
`;
export const ResidentNotMatchingStatusBannerOnClosed = styled.div `
  ${({ theme }) => `
  position:absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 8px;
background-color: ${theme.color.errorRed}15;
    border-bottom-left-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
  
    &::before {
      display: inline-block;
      text-align: center;
      margin-right: 8px;
      width: 17px;
      height: 17px;
      vertical-align: middle;
      font-size: 15px;
      background: transparent;
      color: ${theme.color.darkBlue100};
      border-radius: 50%;
      border: 2px solid ${theme.color.darkBlue100};
      line-height: 20px;
      font-weight: 800;
      content: "!";
    }

    &::after {
      content: "This resident information doesn't match.";
      font-size: 14px;
      vertical-align: middle;
      font-weight: 400;
    }
  }`}
`;
export const ResidentMightExistStatusBannerOnClosed = styled.div `
  ${({ theme }) => `
  position:absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 8px;
background-color: ${theme.color.primary}15;
    border-bottom-left-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
  
    &::before {
      display: inline-block;
      text-align: center;
      margin-right: 8px;
      width: 17px;
      height: 17px;
      vertical-align: middle;
      font-size: 15px;
      background: transparent;
      color: ${theme.color.darkBlue100};
      border-radius: 50%;
      border: 2px solid ${theme.color.darkBlue100};
      line-height: 20px;
      font-weight: 800;
      content: "!";
    }

    &::after {
      content: "This resident may already exist.";
      font-size: 14px;
      vertical-align: middle;
      font-weight: 400;
    }
  }`}
`;
